import styled from '@emotion/styled'

export const Container = styled('div')`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
`

export const Title = styled('p')`
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 24px;
`
